import { render, staticRenderFns } from "./NarasuVocacolleCampaign202210.vue?vue&type=template&id=364566b8&scoped=true&"
import script from "./NarasuVocacolleCampaign202210.vue?vue&type=script&lang=js&"
export * from "./NarasuVocacolleCampaign202210.vue?vue&type=script&lang=js&"
import style0 from "./NarasuVocacolleCampaign202210.vue?vue&type=style&index=0&id=364566b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364566b8",
  null
  
)

export default component.exports